




















































































































import {Component, Mixins} from 'vue-property-decorator';
import MallInfoMixin from '@/components/product/ProductListMallInfoMixin';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import DateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import {changeDateFormat} from '@/utils/dateUtils';
import {momentAdd} from '@/utils/dateUtils';
import {toI18n} from '@/utils/commonUtils';

@Component({
  components: {
    PageFormSelect,
    DateRangePicker
  }
})
export default class DeliveryDate extends Mixins(MallInfoMixin) {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  private get mallProductNos(): string {
    return this.$route.params.mallProductNos;
  }

  private get isDeliveryDateHide(): string {
    return this.deliveryDateYn === 'Y' ? '' : 'hide';
  }

  private get isDeliveryPeriodYnHide(): boolean {
    return this.deliveryPeriodYn === 'Y' ? true : false;
  }

  private get isdaysAfterPurchaseYnHide(): string {
    return this.daysAfterPurchaseYn === 'Y' ? '' : 'hide';
  }

  private get getPeriod() {
    return this.deliveryPeriodYn === 'Y'
      ? {
          endDate: this.dateReceiveData.endYmd,
          startDate: this.dateReceiveData.startYmd
        }
      : null;
  }

  private get getDaysAfterPurchase() {
    return this.daysAfterPurchaseYn === 'Y' ? this.daysAfterPurchaseValue : null;
  }

  private deliveryDueDate = {
    daysOfTheWeek: [],
    period: {
      endDate: '',
      startDate: ''
    },
    daysAfterPurchase: '0'
  };

  private deliveryDateYn = 'N';
  private deliveryPeriodYn = 'N';
  private deliveryDaysOfWeek = ['MON', 'TUE', 'WED', 'THU', 'FRI'];
  private deliveryDaysOfWeekAll = true;
  private daysAfterPurchaseYn = 'N';

  private daysAfterPurchase = Array.from(Array(30).keys()).map((n) => {
    return {value: n + 1 + '', label: n + 1 + ' ' + this.toI18n('WORK')};
  });
  private daysAfterPurchaseValue = '1';

  private today: string = changeDateFormat('', 'YYYY-MM-DD');
  private initRangeStartYmd = this.today;

  private dateData: {startYmd: string; endYmd: string} = {
    startYmd: this.today,
    endYmd: momentAdd(this.today, [3, 'M'], 'YYYY-MM-DD')
  };

  private dateReceiveData = {...this.dateData};

  private dateDataChange({startYmd, endYmd}: any): void {
    this.dateReceiveData = {startYmd, endYmd};
  }

  private deliveryDaysOfWeekChange() {
    this.$nextTick(() => {
      if (this.deliveryDaysOfWeek.length === 5) {
        this.deliveryDaysOfWeekAll = true;
      } else {
        this.deliveryDaysOfWeekAll = false;
      }
    });
  }
  private deliveryDaysOfWeekAllChange() {
    if (this.deliveryDaysOfWeekAll) {
      this.deliveryDaysOfWeek = ['MON', 'TUE', 'WED', 'THU', 'FRI'];
    } else {
      this.deliveryDaysOfWeek = [];
    }
  }

  private changeDeliveryYn() {
    setTimeout(() => {
      const contentWidth = $('#container').width() + 20;
      const contentHeight = $('#container').height() + 80;
      window.resizeTo(contentWidth, contentHeight);
    });
  }

  private deliveryDateYnChange() {
    this.changeDeliveryYn();
  }

  private save() {
    const params = {
      mallProductNos: this.mallProductNos
    };

    let deliveryDueDate = {};
    if (this.deliveryDateYn === 'Y') {
      Object.assign(deliveryDueDate, {
        daysOfTheWeek: [...this.deliveryDaysOfWeek],
      })

      if (this.getPeriod) {
        Object.assign(deliveryDueDate, {
          period: this.getPeriod
        })
      }

      if (this.getDaysAfterPurchase) {
        Object.assign(deliveryDueDate, {
          daysAfterPurchase: Number(this.getDaysAfterPurchase)
        })
      }
    } else {
      deliveryDueDate = null;
    }

    const data : any = {
      deliveryDueDate
    };

    this.$api.patchProducts({params, data}).then(({data}: any) => {
      if (data.failures && data.failures.length) {
        return alert(data.failures[0].message);
      }
      window.opener.postMessage({modifyDelivery: true, data: JSON.parse(JSON.stringify(data))});
      this.close();
    });
  }

  private close() {
    window.close();
  }

  private created() {
    document.body.classList.add('popup', 'popup_large');
    this.$api
      .getProductsMallProductNo({
        pathParams: {
          mallProductNo: this.mallProductNos
        }
      })
      .then(({data}: any): void => {
        const {deliveryDueDate} = data;
        if (deliveryDueDate) {
          Object.assign(this.deliveryDueDate, deliveryDueDate);
          const {period, daysOfTheWeek, daysAfterPurchase} = this.deliveryDueDate;
          if (period) {
            this.deliveryPeriodYn = 'Y';
            Object.assign(this.dateData, {
              startYmd: period.startDate,
              endYmd: period.endDate
            });
          } else {
            this.deliveryPeriodYn = 'N';
          }

          if (daysOfTheWeek && daysOfTheWeek.length) {
            this.deliveryDaysOfWeek = daysOfTheWeek;
            daysOfTheWeek.length === 5 ? (this.deliveryDaysOfWeekAll = true) : (this.deliveryDaysOfWeekAll = false);
          } else {
            this.deliveryDaysOfWeekAll = false;
            this.deliveryDaysOfWeek = [];
          }

          if (daysAfterPurchase && Number(daysAfterPurchase) > 0) {
            this.daysAfterPurchaseValue = daysAfterPurchase + '';
            this.daysAfterPurchaseYn = 'Y';
          } else {
            this.daysAfterPurchaseValue = '1';
            this.daysAfterPurchaseYn = 'N';
          }

          this.deliveryDateYn = 'Y';
        } else {
          this.deliveryDateYn = 'N';
        }

        this.changeDeliveryYn();
      });

    window.name = 'deliveryDate';
  }
}
